import { AnyAction } from 'redux';
import { call, put, takeEvery } from 'redux-saga/effects';

import { getMetaForDocumentId } from 'api/api';
import {
  fetchDocumentMetaErrorAction,
  fetchDocumentMetaStartAction,
  fetchDocumentMetaSuccessAction,
} from 'actions/documentMeta';
import { GET_DOCUMENT_META } from 'actions/documentMeta/types';
import { fetchDocumentFile } from 'sagas/documentFile';
import {
  getImportedReport,
  accuracyReportToMetadata,
} from 'pqaAccuracy/dataTransfer/reportImportCache';
import { DocumentMetaType } from 'types/document';

export function* fetchDocumentMeta({ documentId, documentVersion }: AnyAction) {
  try {
    const cached = getImportedReport();
    const metadata = cached && accuracyReportToMetadata(cached);
    console.debug('imported documentMeta', metadata);

    yield put(fetchDocumentMetaStartAction());
    const { data: documentMetaAPI } = yield call(
      getMetaForDocumentId,
      metadata?.id ?? documentId,
      metadata?.version ?? documentVersion
    );
    const documentMeta: DocumentMetaType = {
      ...documentMetaAPI,
      ...metadata,
      availableSsiVersions:
        metadata?.availableSsiVersions ?? documentMetaAPI?.availableSsiVersions,
      url: documentMetaAPI.url,
    };

    console.debug('resulting documentMeta', documentMeta);
    yield call(fetchDocumentFile, documentMeta.url);

    yield put(
      fetchDocumentMetaSuccessAction({
        ...documentMeta,
        version: documentVersion,
      })
    );
  } catch (e) {
    console.error(e);
    yield put(
      fetchDocumentMetaErrorAction(
        e.response?.data?.message,
        e.response?.status
      )
    );
  }
}

export default function* watchFetchDocumentMeta() {
  yield takeEvery(GET_DOCUMENT_META, fetchDocumentMeta);
}
